import { useTranslation } from '../presentation/common/useTranslation.js';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { RoleIcon } from './GameIcon';
import Skeleton from './Skeleton';
import LandingCleanupScene from './LandingCleanupScene';
import '../styles/world.css';
import '../pages/Landing.css';

const ROLE_KEYS = ['ADVENTURER', 'TRIBUNAL', 'GUILD', 'PARTNER'];
export function PlaceholderText({ loading, children }) {
  return loading ? <span className="landing-placeholder-text">{children}</span> : children;
}

// Share typography and responsive structure to preserve translated line wraps.
export default function LandingIntro({ loading = false }) {
  const { t } = useTranslation();
  const c = t('landing', { returnObjects: true });
  return <div aria-hidden={loading || undefined} className={loading ? 'landing-intro-loading' : undefined}>
      {/* Hero Section */}
      <section className="landing-hero landing-hero--interactive relative overflow-hidden border-b border-[#bda16b]/20 bg-[#061018]">
        <LandingCleanupScene loading={loading}>
        <div className="landing-hero-copy">
          <p className="guild-kicker text-xs leading-relaxed sm:text-sm">
            <PlaceholderText loading={loading}>{c.eyebrow}</PlaceholderText>
          </p>

          {/* Title */}
          <h1 tabIndex={-1} className="font-serif font-normal tracking-tight text-[#f0ede6]"><PlaceholderText loading={loading}>{t('landing.hero_prefix')} <span className="bg-gradient-to-r from-[#eed8ab] via-[#f7e2a9] to-[#d9b56d] bg-clip-text text-transparent font-medium">{t('landing.hero_emphasis')}</span></PlaceholderText></h1>

          {/* Subtitle */}
          <p className="landing-hero-subtitle text-[#b5b1cb]">
            <PlaceholderText loading={loading}>{c.subtitle}</PlaceholderText>
          </p>

        </div>

          {/* Actions */}
          <div className="landing-hero-actions">
            <Link tabIndex={loading ? -1 : undefined}
              to="/register"
              className="world-button-primary"
            >
              <span><PlaceholderText loading={loading}>{c.start}</PlaceholderText></span>
              <ArrowRight className="w-4 h-4 stroke-[2.5]" style={loading ? { visibility: 'hidden' } : undefined} />
            </Link>
            <Link tabIndex={loading ? -1 : undefined} to="/login" className="world-button-secondary landing-hero-login">
              <PlaceholderText loading={loading}>{t('common.login')}</PlaceholderText>
            </Link>
          </div>
        </LandingCleanupScene>
      </section>

      {/* Four connected parts of Goodvale */}
      <section className="landing-roles-section" aria-labelledby="landing-roles-title">
        <div className="landing-roles-inner">
          <div className="landing-roles-heading">
            <span className="guild-kicker"><PlaceholderText loading={loading}>{t('landing.roles_kicker')}</PlaceholderText></span>
            <h2 id="landing-roles-title"><PlaceholderText loading={loading}>{t('landing.roles_title')}</PlaceholderText></h2>
            <p><PlaceholderText loading={loading}>{t('landing.roles_intro')}</PlaceholderText></p>
          </div>
          <ol className="landing-roles-list">
            {(c?.cards ?? []).map(([title, description], index) => (
              <li className="landing-role" key={ROLE_KEYS[index]}>
                <div className="landing-role-emblem">
                  {loading ? <Skeleton className="h-full w-full" style={{ borderRadius: '50%' }} /> : <RoleIcon roleKey={ROLE_KEYS[index]} alt="" className="guild-icon" />}
                </div>
                <div className="landing-role-copy">
                  <span className="landing-role-action"><PlaceholderText loading={loading}>{t(`landing.role_actions.${index}`)}</PlaceholderText></span>
                  <h3><PlaceholderText loading={loading}>{title}</PlaceholderText></h3>
                  <p><PlaceholderText loading={loading}>{description}</PlaceholderText></p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </section>

  </div>;
}
